module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_5-e27fff7625e7835f7642812fcffc2ee1.png";